import { useState } from "react";
import CustomModal from "components/Modals/CustomModal";
import profilePic from "components/user-icon.png";
import { UserCard } from "./UserCard";
import { UserFormTypes } from "constants/index";
import styles from "./UserListGrid.module.scss";

export const UserListGrid = ({
  userListKey,
  listTitle,
  list,
  toggleActiveStatusHandler,
  loggedInUserId,
  handleDeleteUser,
  getConfigNames,
  noUserMessage,
  userRole = "",
}) => {
  const [infoModal, setInfoModal] = useState("");
  const isRoutingUser = userRole === UserFormTypes.ROUTING_USER;
  return (
    <div className={`${styles["list-container"]}`}>
      {listTitle && <h6>{listTitle}</h6>}
      {list?.length > 0 ? (
        <div className={`${styles["users-grid"]}`}>
          {list?.map((item, index) => {
            const marqueeText = getConfigNames(item.dataStreamConfigIds ?? []);
            return (
              <UserCard
                key={`${userListKey}-${index}`}
                profileSrc={
                  isRoutingUser
                    ? ""
                    : item.profilePicture
                      ? item.profilePicture
                      : profilePic
                }
                firstName={item.firstName}
                lastName={item.lastName}
                userRoleType={isRoutingUser ? userRole : item.userRoleType}
                userId={
                  isRoutingUser ? item.companyRouteUserId : item.companyUserId
                }
                viewUserParam={
                  isRoutingUser
                    ? UserFormTypes.VIEW_ROUTING_USER
                    : UserFormTypes.VIEW_USER
                }
                isActive={item.isActive}
                loggedInUserId={loggedInUserId}
                handleDeleteUser={handleDeleteUser}
                toggleActiveStatusHandler={toggleActiveStatusHandler}
                marqueeText={marqueeText}
                setInfoModal={setInfoModal}
              />
            );
          })}
        </div>
      ) : (
        <div
          className="align-items-center d-flex justify-content-center text-center text-no-data"
          style={{ height: "20vh" }}
        >
          {noUserMessage}
        </div>
      )}
      <CustomModal
        show={!!infoModal}
        centered
        noHeader
        body={
          <h5
            className="modal-title text-center w-100"
            style={{ color: "#004e5c" }}
          >
            {infoModal}
          </h5>
        }
        centerFooter
        onOk={() => {
          setInfoModal("");
        }}
      />
    </div>
  );
};
